"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.namespace = 'backgroundImage';
exports.SET_BACKGROUND_IMAGE_CONFIG = exports.namespace + "/SET_BACKGROUND_IMAGE_CONFIG";
//# sourceMappingURL=constants.js.map